
// Função simplificada para detectar apenas se o usuário está perguntando sobre PDF
export const detectPDFQuestion = (message: string): boolean => {
  const pdfKeywords = [
    'gerar pdf',
    'gere um pdf',
    'gere pdf',
    'baixar pdf',
    'baixe pdf',
    'exportar pdf',
    'exporte pdf',
    'criar pdf',
    'crie um pdf',
    'fazer pdf',
    'faça um pdf',
    'salvar pdf',
    'salve pdf',
    'download pdf',
    'me envia um pdf',
    'envie um pdf',
    'quero um pdf',
    'quero pdf',
    'preciso de um pdf',
    'preciso pdf',
    'pdf com',
    'em pdf',
    'formato pdf',
    'no formato pdf',
    'transformar em pdf',
    'converter para pdf',
    'converter em pdf',
    'document pdf',
    'documento pdf',
    'como baixar pdf',
    'onde baixar pdf',
    'botão pdf'
  ];
  
  const normalizedMessage = message.toLowerCase().trim();
  return pdfKeywords.some(keyword => normalizedMessage.includes(keyword));
};
